import { combineReducers } from "@reduxjs/toolkit";
import tariffsReducer from "./slices/tariffs";
import selectTariffReducer from "./slices/selectedTariff";
import selectInsuranceReducer from "./slices/insurances";
import selectPersonalScoreReducer from "./slices/personalScore";
import requestPlaceReducer from "./slices/requestPlace";
import sumTermReducer from "./slices/selectedSumTerm";
import lifeInsuranceReducer from "./slices/lifeInsuranceSlice";
import personalScoreReducer from "./slices/personalScoreSlice";
import voximplantReducer from "./slices/voximplant";
import userInfoReducer from "./slices/userInfo";
import selectedDaysReducer from "./slices/selectedDays";
var rootReducer = combineReducers({
    tariffs: tariffsReducer,
    selectedTariff: selectTariffReducer,
    insurance: selectInsuranceReducer,
    personalScore: selectPersonalScoreReducer,
    requestPlace: requestPlaceReducer,
    sumTerm: sumTermReducer,
    lifeInsurance: lifeInsuranceReducer,
    creditRating: personalScoreReducer,
    voximplant: voximplantReducer,
    userInfo: userInfoReducer,
    selectedDays: selectedDaysReducer,
});
export default rootReducer;
